<template>
  <section class="nup-hero">
    <div class="nup-hero__stage">
      <img
        class="nup-hero__kv"
        :src="kvSrc"
        :alt="copy.heroAlt"
      >
    </div>
    <div class="nup-hero__chrome">
      <button
        v-if="!isPC"
        type="button"
        class="nup-hero__rules"
        @click="$emit('rules')"
      >
        {{ copy.rules }}
      </button>
      <div
        v-if="showEnroll"
        data-nup-cta
        class="nup-hero__cta"
      >
        <button
          type="button"
          class="nup-hero__enroll"
          :disabled="submitting"
          :style="{ backgroundImage: 'url(' + btnBg + ')' }"
          @click="$emit('enroll')"
        >
          {{ copy.enrollNow }}
        </button>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { getCopy } from '../constants/copy';
import { useNupLang } from '../composables/use-nup-lang';
import { usePageTypeFlag } from '../composables/use-page-type';
import btnBg from '../assets/rewards/btn-bg.png';
import heroKv from '../assets/hero-kv.png';
import pcBanner from '../assets/banner.png';
import enHeroKv from '../assets/en/hero-kv.png';
import enPcBanner from '../assets/en/banner.png';
const __sfc_main = {};
__sfc_main.props = {
  showEnroll: {
    type: Boolean,
    default: true
  },
  submitting: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    isPC
  } = usePageTypeFlag();
  const {
    isEn
  } = useNupLang();
  const copy = computed(() => getCopy(isEn.value));
  const kvSrc = computed(() => {
    if (isPC.value) {
      return isEn.value ? enPcBanner : pcBanner;
    }
    return isEn.value ? enHeroKv : heroKv;
  });
  return {
    btnBg,
    isPC,
    copy,
    kvSrc
  };
};
export default __sfc_main;
</script>

<style scoped>
.nup-hero {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.nup-hero__stage {
  position: relative;
  width: 100%;
}

.nup-hero__kv {
  display: block;
  width: 100%;
  height: auto;
}

.nup-hero__chrome {
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.nup-hero__rules {
  position: absolute;
  z-index: 2;
  top: 2.8%;
  right: 3.9%;
  height: 58px;
  padding: 0 24px;
  border: 1px solid #fff;
  border-radius: 29px;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 24px;
  line-height: 58px;
  pointer-events: auto;
  cursor: pointer;
}

.nup-hero__cta {
  position: absolute;
  z-index: 2;
  left: 50%;
  bottom: 40px;
  width: 614px;
  transform: translateX(-50%);
  pointer-events: auto;
}

.nup-hero__enroll {
  display: block;
  width: 614px;
  height: 106px;
  padding: 0;
  border: none;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  color: #fff;
  font-size: 40px;
  font-weight: 600;
  line-height: 106px;
  text-align: center;
  cursor: pointer;
}

.nup-hero__enroll:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.nup-page.is-pc .nup-hero {
  /* 新 KV 3840×974，按 2x 展示 1920×487，两侧底色跟切图 */
  height: 487px;
  background: #7e0c00;
  overflow: hidden;
}

.nup-page.is-pc .nup-hero__stage {
  width: 1920px;
  height: 487px;
  max-width: none;
  left: 50%;
  transform: translateX(-50%);
}

.nup-page.is-pc .nup-hero__kv {
  width: 1920px;
  height: 487px;
  max-width: none;
}

.nup-page.is-pc .nup-hero__chrome {
  left: 50%;
  right: auto;
  width: 1200px;
  max-width: 100%;
  transform: translateX(-50%);
}

.nup-page.is-pc .nup-hero__cta {
  left: 0;
  bottom: 67px;
  width: 148px;
  transform: none;
}

.nup-page.is-pc .nup-hero__enroll {
  box-sizing: border-box;
  width: 148px;
  height: 56px;
  overflow: hidden;
  border: 1px solid #fff;
  border-radius: 28px;
  font-size: 20px;
  line-height: 54px;
}

.nup-page.is-pc.is-en .nup-hero__cta {
  width: 208px;
}

.nup-page.is-pc.is-en .nup-hero__enroll {
  width: 208px;
}
</style>
